import { render } from "./Multicare.vue?vue&type=template&id=33452aab&scoped=true"
import script from "./Multicare.vue?vue&type=script&lang=js"
export * from "./Multicare.vue?vue&type=script&lang=js"

import "./Multicare.vue?vue&type=style&index=0&id=33452aab&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-33452aab"

export default script